import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=38bc5b7d&scoped=true"
import script from "./Modal.js?vue&type=script&lang=js&external"
export * from "./Modal.js?vue&type=script&lang=js&external"
import style0 from "./Modal.vue?vue&type=style&index=0&id=38bc5b7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bc5b7d",
  null
  
)

export default component.exports